import router from './router';
import { useSessionStore, useNotificationStore } from './plugins/store';
import * as Persistance from './plugins/persistance';
import { getMotivationalMessage, setSession } from './services';
const MainLayout = () => import('./components/layout/MainLayout');
const LoadingRoute = () => import('./components/loaders/LoadingRoute');

export {
  router,
  MainLayout,
  useSessionStore,
  useNotificationStore,
  getMotivationalMessage,
  Persistance,
  setSession,
  LoadingRoute,
};

